import React, { useState } from "react";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
import { useNavigate } from "react-router-dom";

const Register = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const handleRegister = async (e) => {
        e.preventDefault();
        try {
            await createUserWithEmailAndPassword(auth, email, password);
            alert("Регистрация прошла успешно!");
            navigate("/");
        } catch (err) {
            setError(err.message);
        }
    };

    return (
        <form
            onSubmit={handleRegister}
            style={{
                maxWidth: "400px",
                margin: "0 auto",
                padding: "20px",
                border: "2px solid #00FFFF",
                borderRadius: "8px",
                background: "rgba(10, 10, 10, 0.8)",
                boxShadow: "0 0 10px rgba(0, 255, 255, 0.5)"
            }}
        >
            <h2 style={{
                color: "#00FFFF",
                textShadow: "0 0 5px #00FFFF",
                textAlign: "center",
                marginBottom: "20px",
                fontFamily: "'Orbitron', sans-serif"
            }}>
                Регистрация
            </h2>

            <div style={{ marginBottom: "15px" }}>
                <input
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    style={{
                        width: "100%",
                        padding: "12px 12px",
                        borderRadius: "4px",
                        background: "#111",
                        border: "2px solid #00FFFF",
                        color: "#FFFFFF",
                        fontFamily: "'Orbitron', sans-serif",
                        fontSize: "14px",
                        boxShadow: "0 0 5px rgba(0, 255, 255, 0.3)"
                    }}
                    required
                />
            </div>

            <div style={{ marginBottom: "20px" }}>
                <input
                    type="password"
                    placeholder="Пароль"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                />
            </div>

            <button
                type="submit"
                style={{
                    width: "100%",
                    padding: "10px",
                }}
            >
                Зарегистрироваться
            </button>
            {error && <p className="text-red-500">{error}</p>}
        </form>
    );
};

export default Register;